// extracted by mini-css-extract-plugin
export default {"Vcard":"VirtualAccount_Vcard__LqTk9","VAcctTxt":"VirtualAccount_VAcctTxt__5H9Iq","VFundTxt":"VirtualAccount_VFundTxt__Gblxj","VBank":"VirtualAccount_VBank__vS-Za"};